import { render } from "./notificationButton.vue?vue&type=template&id=1b1d4ca6&scoped=true"
import script from "./notificationButton.vue?vue&type=script&lang=js"
export * from "./notificationButton.vue?vue&type=script&lang=js"

import "./notificationButton.vue?vue&type=style&index=0&id=1b1d4ca6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1d4ca6"]])

export default __exports__